import { JSX } from 'react'

import { LabelValue, Skeleton } from '~/components/component-library'
import { SponsoredFeeAmount } from '~/components/txn-display/cost-display/SponsoredFeeAmount'
import { FeeAmount } from '~/components/txn-display/cost-display/feeAmount'

type CostDisplayBaseProps = {
  isLoading: boolean
  isSponsored: boolean
  fee: FeeAmount
  paidBy?: string
}

type CostDisplayCollapsibleProps =
  | {
      isCollapsible: true
      defaultOpen?: boolean
      children: JSX.Element
    }
  | {
      isCollapsible?: false
      defaultOpen?: never
      children?: never
    }

type CostDisplayProps = CostDisplayBaseProps & CostDisplayCollapsibleProps

export const CostDisplay = ({
  isLoading,
  isSponsored,
  fee,
  paidBy,
  isCollapsible,
  defaultOpen,
  children,
}: CostDisplayProps) => {
  const props = {
    label: 'Gas fees',
    size: 'small' as const,
    value: (
      <div className="flex items-center gap-2 text-sm">
        {isLoading ? (
          <Skeleton length={2} height={1} />
        ) : (
          <SponsoredFeeAmount
            fee={fee}
            isSponsored={isSponsored}
            paidBy={paidBy}
          />
        )}
      </div>
    ),
  }

  if (isCollapsible) {
    return (
      <LabelValue {...props} isCollapsible defaultOpen={defaultOpen}>
        {children}
      </LabelValue>
    )
  }

  return <LabelValue {...props} />
}
